// Hook pour détecter la taille d'écran et gérer le responsive
import { useState, useEffect } from "react";

interface Breakpoints {
  sm: number;
  md: number;
  lg: number;
  xl: number;
}

const breakpoints: Breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
};

interface ResponsiveState {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  screenWidth: number;
  screenHeight: number;
}

export const useResponsive = (): ResponsiveState => {
  const [screenSize, setScreenSize] = useState<ResponsiveState>({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
    screenWidth: 0,
    screenHeight: 0,
  });

  useEffect(() => {
    const updateScreenSize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;

      setScreenSize({
        isMobile: width < breakpoints.md,
        isTablet: width >= breakpoints.md && width < breakpoints.lg,
        isDesktop: width >= breakpoints.lg,
        screenWidth: width,
        screenHeight: height,
      });
    };

    // Initialiser
    updateScreenSize();

    // Écouter les changements de taille
    window.addEventListener("resize", updateScreenSize);

    // Nettoyer
    return () => window.removeEventListener("resize", updateScreenSize);
  }, []);

  return screenSize;
};

// Hook spécifique pour les explications
export const useExplanationResponsive = () => {
  const { isMobile } = useResponsive();

  return {
    isMobile,
    shouldUseMobileLayout: isMobile,
  };
};
